import { NotificationService } from '@ds/services/NotificationService'
import { defineComponent } from 'vue'

import CANotification from './CANotification'

export default defineComponent({
	name: 'CANotifications',

	setup() {
		const notificationService = NotificationService.useNotifications()

		return () =>
			<div class="ca-notification-container" data-test="design-system-notification">
				{notificationService.notifications.value.map(notification =>
					<CANotification key={notification.id} notification={notification} />
				)}
			</div>
	},
})
